import { getDispatch } from '../get-dispatch';
import { DispatchAction } from '../utility/dispatch-action';
import { AuthActions, AUTH_STATE_NAMESPACE } from './auth.module.types';

export const dispatchAuthAction: DispatchAction<AuthActions> =
  getDispatch(AUTH_STATE_NAMESPACE);
